import {getScrollbarWidth} from "../utils"

export default {
  init: function () {
    const t = this

    t.show = t.show.bind(t)
    t.hide = t.hide.bind(t)
    t.onHide = t.onHide.bind(t)
    t.onShow = t.onShow.bind(t)
    t.closeOnEsc = t.closeOnEsc.bind(t)
    t.current = null

    ;[...document.querySelectorAll('[id^="popup-"]')].forEach((el) => {
      const popupLinks = [...document.querySelectorAll(`[data-link-popup-id="${el.id.replace('popup-', '')}"]`)]

      popupLinks.forEach((popupLink) => {
        popupLink.addEventListener("click", (e) => {
          e.preventDefault()

          t.current = {
            el,
            link: popupLink,
            close: el.querySelector(".popup__close"),
          }
  
          t.show()
        })
      })
    })
  },
  onShow: function(e) {
    if (e.propertyName == "opacity") {
      const t = this
      const {el, close} = t.current

      // el.setAttribute("aria-hidden", "false")
      close.addEventListener("click", t.hide)
      document.addEventListener("keyup", t.closeOnEsc)
      el.removeEventListener("transitionend", t.onShow)
      close.focus()
    }
  },
  onHide: function(e) {
    if (e.propertyName == "opacity") {
      const t = this
      const {el, link} = t.current

      document.documentElement.classList.remove("overflow-hidden")
      document.body.style.marginRight = null
      el.removeEventListener("transitionend", t.onHide)
      link.focus()
      t.current = null
    }
  },
  closeOnEsc: function(e) {
    if (e.key == "Escape") this.hide()
  },
  hide: function(e) {
    if (e) {
      e.preventDefault()
    }

    const t = this
    const {el, close} = t.current

    el.classList.remove(
      "top-0",
      "visible",
      "opacity-100",
      "!delay-0",
    )
    el.classList.add(
      "-top-offscreen",
      "invisible",
      "opacity-0"
    )
    close.removeEventListener("click", t.hide)
    document.removeEventListener("keyup", t.closeOnEsc)
    el.addEventListener("transitionend", t.onHide)
    // el.setAttribute("aria-hidden", "true")
  },
  show: function () {
    const t = this
    const {el} = t.current

    el.classList.remove(
      "-top-offscreen",
      "invisible",
      "opacity-0",
    )
    el.classList.add(
      "top-0",
      "visible",
      "opacity-100",
      "!delay-0",
    )

    document.body.style.marginRight = `${getScrollbarWidth()}px`
    document.documentElement.classList.add("overflow-hidden")
    el.addEventListener("transitionend", t.onShow)
  },
}
